import React, { useEffect } from 'react';

// Simple floating reactions overlay. Reactions: [{ id, emoji, x, y }]
export default function ReactionOverlay({ reactions = [] }) {
  useEffect(() => {
    // Inject keyframes once
    const id = 'reaction-overlay-keyframes';
    if (!document.getElementById(id)) {
      const style = document.createElement('style');
      style.id = id;
      style.textContent = `
        @keyframes reactionFloatUp { 
          0% { transform: translate3d(0, 0, 0) scale(0.9); opacity: 0; }
          10% { opacity: 1; }
          100% { transform: translate3d(0, -140px, 0) scale(1.2); opacity: 0; }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={{ position: 'fixed', left: 0, top: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 9500 }}>
      {reactions.map((r) => (
        <div
          key={r.id}
          style={{
            position: 'fixed',
            left: (r.x || 0),
            top: (r.y || 0),
            fontSize: 28,
            animation: 'reactionFloatUp 1.3s ease-out forwards',
            animationDelay: r.delay || '0s',
            willChange: 'transform, opacity',
            filter: 'drop-shadow(0 6px 10px rgba(0,0,0,0.25))',
          }}
        >
          <span>{r.emoji}</span>
        </div>
      ))}
    </div>
  );
}


